import { Box, useMediaQuery } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import { hyphenatePhoneNumber } from '@constants/phoneNumbers';
import Link from 'next/link';
import CtaWrapper from './CtaWrapper';

function MedicareAdvocate({ phoneNumber }) {
  const [isLargerThan600] = useMediaQuery('(min-width: 600px)');

  const hyphenatedPhoneNumber = hyphenatePhoneNumber(phoneNumber);
  const text = isLargerThan600
    ? `Call ${hyphenatedPhoneNumber} to Speak with a Medicare Advocate`
    : `Call ${hyphenatedPhoneNumber}`;

  const renderCta = () => (
    <Box display="flex" flexDirection="column">
      <Body1>Talk to one of our Licensed Medicare Agents today to find the right plans for you.</Body1>
      <Link href={`tel:${hyphenatedPhoneNumber}`}>
        <Button
          className="medicare_advocate_call_link"
          width="100%"
          margin="1rem 0 0 0"
          suppressHydrationWarning // Component depends on Media Query and SSR
        >
          {text}
        </Button>
      </Link>
    </Box>
  );

  return <CtaWrapper header="Speak with a Medicare Advocate" renderCta={renderCta} />;
}

export default MedicareAdvocate;
